import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles, Loader2 } from 'lucide-react';
import { Signal, SignalCategory } from '@momentum/types';

interface ViewGoalSignalsProps {
  relatedSignals?: Partial<Signal>[];
  isLoading?: boolean;
}

export const ViewGoalSignals: React.FC<ViewGoalSignalsProps> = ({
  relatedSignals,
  isLoading,
}) => {
  const { t } = useTranslation('goals');

  if (isLoading) {
    return (
      <div>
        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-3 flex items-center gap-2">
          <Sparkles className="h-3.5 w-3.5" />
          {t('relevantSignals')}
        </label>
        <div className="bg-blue-50/50 border border-blue-100 rounded-lg p-4 flex items-center justify-center">
          <Loader2 className="h-5 w-5 animate-spin text-blue-500" />
        </div>
      </div>
    );
  }

  if (!relatedSignals || relatedSignals.length === 0) {
    return null;
  }

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-3 flex items-center gap-2">
        <Sparkles className="h-3.5 w-3.5" />
        {t('relevantSignals')}
      </label>
      <div className="bg-blue-50/50 border border-blue-100 rounded-lg p-4">
        <ul className="space-y-3">
          {relatedSignals.map((signal, index) => (
            <li key={signal._id} className="flex items-start gap-3">
              <span
                className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${
                  signal.category === SignalCategory.COMMITMENT
                    ? 'bg-amber-100 text-amber-600'
                    : 'bg-blue-100 text-blue-600'
                }`}
              >
                {index + 1}
              </span>
              {signal.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
